const normalize = (value) => (value || '').toString().trim().toLowerCase();

export const canonicalizeRole = (role, accountType) => {
  const normalizedRole = normalize(role);
  const normalizedAccountType = normalize(accountType);

  if (!normalizedRole) {
    return '';
  }

  if (normalizedRole === 'global_admin' || normalizedRole === 'super_admin') {
    return 'global_admin';
  }

  if (normalizedRole === 'university_admin') {
    return 'university_admin';
  }

  if (normalizedRole === 'university_instructor') {
    return 'university_instructor';
  }

  if (normalizedRole === 'vm_instructor') {
    return 'vm_instructor';
  }

  if (normalizedRole === 'admin') {
    return normalizedAccountType === 'university' ? 'university_admin' : 'global_admin';
  }

  if (normalizedRole === 'instructor') {
    return normalizedAccountType === 'university' ? 'university_instructor' : 'vm_instructor';
  }

  if (normalizedRole === 'educator' && normalizedAccountType === 'university') {
    return 'university_instructor';
  }

  return normalizedRole;
};

export const canonicalizeUserRole = (user = {}) => canonicalizeRole(user?.role || user?.legacyRole, user?.accountType);

export const isGlobalAdmin = (user) => canonicalizeUserRole(user) === 'global_admin';

export const isUniversityAdmin = (user) => canonicalizeUserRole(user) === 'university_admin';

export const isUniversityInstructor = (user) => canonicalizeUserRole(user) === 'university_instructor';

export const isTenantScopedAdmin = (user) => isUniversityAdmin(user) || isUniversityInstructor(user);

export const isVirtualMedicInstructor = (user) => canonicalizeUserRole(user) === 'vm_instructor';
